// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentUploadDropzoneContainer {
	margin-bottom: 30px;
}

.documentUploadDropzoneContainer .filepicker {
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background-color: transparent;
	min-height: 200px;
	border: 2px dashed var(--primary-border);
	font-family: var(--font-family-base);
}

.documentUploadDropzoneContainer .filepicker .dz-message {
	display: none;
}

.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {
	z-index: -1;
}

.documentUploadDropzoneIcon {
	position: absolute;
	top: calc(50% - 17px);
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: -1;
}

.documentUploadDropzonePlaceholder {
	position: absolute;
	top: calc((50% + 10px));
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	margin-top: 12px;
	color: var(--primary-foreground);
	z-index: -1;
	padding: 0 12px;
}

@media (max-width: 480px) {
	.documentUploadDropzonePlaceholder {
		top: calc((50% + 20px));
	}
}

/* become a host start */
.documentUploadDropzoneContainer .filepicker {
	min-height: 262px;
	margin-bottom: 12px;
}

.becomeHostDropzoneContainer .filepicker .dz-message {
	display: block;
	padding: 0 12px;
	font-size: 18px;
	font-weight: 500;
	line-height: normal;
	position: absolute;
	top: calc((50% + 10px));
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	margin-top: 12px;
	margin-bottom: 0;
	color: var(--primary-foreground);
	z-index: -1;
	padding: 0 12px;
}

.becomeHostDropzoneUploadText {
	font-size: 14px;
	font-weight: 400;
	line-height: 24px;
	color: var(--secondary-foreground);
}

@media (max-width: 1120px) and (min-width: 768px) {
	.becomeHostDropzoneContainer .filepicker .dz-message {
		top: calc((50% + 20px));
	}
}

@media (max-width: 550px) {
	.becomeHostDropzoneContainer .filepicker .dz-message {
		top: calc((50% + 20px));
	}
}

/* become a host end */

.becomeHostDropzoneContainer .dz-preview .dz-details .dz-filename:hover,
.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {
	overflow: hidden;
	text-overflow: ellipsis;
}

.documentUploadDropzoneContainer .dz-preview.dz-image-preview,
.becomeHostDropzoneContainer .dz-preview.dz-image-preview {
	background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/documentUploadDropzone.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,6BAA6B;CAC7B,iBAAiB;CACjB,wCAAwC;CACxC,oCAAoC;AACrC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,SAAS;CACT,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,SAAS;CACT,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA,wBAAwB;AACxB;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,SAAS;CACT,gCAAgC;CAChC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA,sBAAsB;;AAEtB;;CAEC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;;CAEC,uBAAuB;AACxB","sourcesContent":[".documentUploadDropzoneContainer {\n\tmargin-bottom: 30px;\n}\n\n.documentUploadDropzoneContainer .filepicker {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\toverflow: hidden;\n\tbackground-color: transparent;\n\tmin-height: 200px;\n\tborder: 2px dashed var(--primary-border);\n\tfont-family: var(--font-family-base);\n}\n\n.documentUploadDropzoneContainer .filepicker .dz-message {\n\tdisplay: none;\n}\n\n.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {\n\tz-index: -1;\n}\n\n.documentUploadDropzoneIcon {\n\tposition: absolute;\n\ttop: calc(50% - 17px);\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: -1;\n}\n\n.documentUploadDropzonePlaceholder {\n\tposition: absolute;\n\ttop: calc((50% + 10px));\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\tmargin-top: 12px;\n\tcolor: var(--primary-foreground);\n\tz-index: -1;\n\tpadding: 0 12px;\n}\n\n@media (max-width: 480px) {\n\t.documentUploadDropzonePlaceholder {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n/* become a host start */\n.documentUploadDropzoneContainer .filepicker {\n\tmin-height: 262px;\n\tmargin-bottom: 12px;\n}\n\n.becomeHostDropzoneContainer .filepicker .dz-message {\n\tdisplay: block;\n\tpadding: 0 12px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: normal;\n\tposition: absolute;\n\ttop: calc((50% + 10px));\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 100%;\n\tmargin-top: 12px;\n\tmargin-bottom: 0;\n\tcolor: var(--primary-foreground);\n\tz-index: -1;\n\tpadding: 0 12px;\n}\n\n.becomeHostDropzoneUploadText {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 24px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1120px) and (min-width: 768px) {\n\t.becomeHostDropzoneContainer .filepicker .dz-message {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n@media (max-width: 550px) {\n\t.becomeHostDropzoneContainer .filepicker .dz-message {\n\t\ttop: calc((50% + 20px));\n\t}\n}\n\n/* become a host end */\n\n.becomeHostDropzoneContainer .dz-preview .dz-details .dz-filename:hover,\n.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.documentUploadDropzoneContainer .dz-preview.dz-image-preview,\n.becomeHostDropzoneContainer .dz-preview.dz-image-preview {\n\tbackground: transparent;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
